import { css } from '@emotion/react';
import {
  faClose, faPrint,
} from '@fortawesome/pro-solid-svg-icons';
import { RoundButtonComponent } from '~/_shared/baseComponents/buttons';
import { RoundButtonStyle } from '~/_shared/baseComponents/buttons/roundButton/roundButton.styles';
import type { Theme } from '~/_shared/themes/theme.model';

const wrapperStyle = (theme: Theme) => css({
  padding: '8px 12px',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 10,
  background: theme.reportColors.sectionBackground,
});

type MapExportReportPreviewHeaderProps = Readonly<{
  onPrintClick: () => void;
  onCloseClick: () => void;
}>;

export const MapExportReportPreviewHeaderComponent = (props: MapExportReportPreviewHeaderProps) => {
  return (
    <div css={wrapperStyle}>
      <RoundButtonComponent
        buttonStyle={RoundButtonStyle.Quaternary}
        icon={faPrint}
        onClick={props.onPrintClick}
      />
      <RoundButtonComponent
        icon={faClose}
        onClick={props.onCloseClick}
      />
    </div>
  );
};
